import { useEffect, useState } from 'react';
import * as storage from '../storage';
/** @see https://stackoverflow.com/a/38552302 */
const parseAccessToken = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''));
    return JSON.parse(jsonPayload);
};
export const useWorkspacePermissions = () => {
    const [permissions, setPermissions] = useState({});
    useEffect(() => storage.subscribeToTokenData(data => {
        if (!data) {
            setPermissions({});
            return;
        }
        try {
            const jwt = parseAccessToken(data.accessToken);
            setPermissions(jwt.user.permissions || {});
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('Failed to parse auth token', e);
        }
    }), []);
    const hasPermissions = (resource, actions) => actions.every(action => permissions[resource]?.includes(action));
    return { permissions, hasPermissions };
};
//# sourceMappingURL=useWorkspacePermissions.js.map